<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
var $ = require('jquery')
window.jQuery = $
window.$ = $
require('../../static/js/jQuery.print')
require('../../static/js/jquery.transit.min')
require('../../static/js/carousel.min')
require('../../static/js/pace.min')
require('../../static/js/common')

export default {
  name: 'app'
}
</script>

<style>
@import url('../../static/css/font.css');
@import url('../../static/css/pace-theme-flash.css');
@import url('../../static/css/style.css');
@import url('../../static/css/responsive.css');
</style>



// WEBPACK FOOTER //
// src/components/App.vue